<template>
  <div class="box">
    <div class="headline">
      <div class="top">Step 5 of 5</div>
      Code Options
    </div>
    <b-form>
      <b-form-group description="Do you want to automatically format your code using 'black'?">
        <b-form-checkbox v-model="use_black">Use <strong>black</strong> code formatter</b-form-checkbox>
      </b-form-group>

      <div class="button-row">
        <b-button @click="$emit('prev', exportData())">← Prev</b-button>
        <b-button variant="primary" @click="$emit('next', exportData())">Next &rarr;</b-button>
      </div>
    </b-form>
  </div>
</template>

<script>

export default {
  name: 'CodeOptions',

  props: {
    recipe: {type: Object, required: true}
  },

  data () {
    return {
      use_black: !!this.recipe.use_black
    }
  },

  methods: {
    exportData () {
      return {
        use_black: this.use_black
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/wizard/CodeOptions.vue